import {
  usersLogin,
  getAllRoles,
  getAdminList,
  getClientEntities,
  getUserDetails,
  postCreateAdmin,
  putUpdateClient,
  postCreateClient,
  getClients,
  putDeleteClient,
  putStoreStatus,
  putUpdateClientEntity,
  postCreateClientEntity,
  getEntityTypeList,
  getVenueList,
  putVenueStatus,
  postCreateVenue,
  putUpdateVenue,
  putUpdateAdminDetails,
  putUpdateAdminRole,
  putUpdateAdminStatus,
  getShopType,
  getStarRating,
  getBriefJson,
  putUpdateEditors,
  putVenueEditors,
  getVisitTimes,
  postVisitTimes,
  putVisitTimes,
  postClientEntityTemplate,
  getClientEntityTemplateByClientEntityId,
  postVenueTemplate,
  getVenueEntityTemplateByClientEntityId,
  putClientEntityTemplate,
  getAllocations,
  putUpdateAllocation,
  postCreateAllocations,
  getAllShoppersApplications,
  putUpdateShopperApplicationStatus,
  getAppliedAllocations,
  postUpdateAppliedAllocationStatus,
  getShopper,
  getOrphanAllocations,
  getNearbyShopper,
  postInviteShopper,
  getcategories,
  getentities,
  addquestions,
  updatequestions,
  getquestions,
  getquestiontemplate,
  uploadVenueImage,
  addquestiontemplate,
  updatequestiontemplate,
  deletequestiontemplate,
  gettemplatequestions,
  addtemplatequestions,
  removetemplatequestions,
  putCancelJob,
  getcliententityquestions,
  addbusinessquestions,
  removebusinessquestions,
  updatebusinessquestions,
  addvenuequestions,
  getvenuequestions,
  removevenuequestions,
  updatevenuequestions,
  updatevenuequestionorder,
  updatevenuecategoryorder,
  getClientDbName,
  masterRating,
  reportlist,
  getShopperFeedback,
  postShopperFeedback,
  getReportDetails,
  scoreCardStep1,
  scoreCardStep2,
  scoreCardStep3,
  deletePhotos,
  updatevisittime,
  reportPdf,
  updateReportStatus,
  getStarRatingReport,
  getSpentReport,
  getClientEntityByClientGroupId,
  postAreaManager,
  getAreaManagers,
  putAreaManager,
  getAddOnQuestions,
  uploadDocuments,
  postQuizQuestion,
  getQuizQuestions,
  putQuizQuestions,
  getShopperList,
  putShopperDetails,
  putShopperFinancialDetails,
  getShopperDetails,
  getShopperRelativeVenues,
  getShopperVenueMap,
  getShopperPopUpDetails,
  getCategoryList,
  addCategory,
  updateCategory,
  quizreTake,
  getManageRegions,
  postRegion,
  putRegion,
  postAssignRegionToClientEntity,
  getBusinessRegions,
  getClientEntityComparisionsByEntityType,
  getVenuePreviousReport,
  getApprovedAllocationShopper,
  getRegionBusinessDetails,
  postregionBusinessDetail,
  postQuizBrief,
  putQuizBrief,
  delReportMessage,
  getAllocationCriteriaDetails,
  createAirTasker,
  updateAirTasker,
  deleteAirTasker,
  getAirTasker,
  deleteInvitedAirTasker,
  getallocations,
  createbundleallocations,
  getbundleallocations,
  getappliedbundleallocations,
  getbundlelist,
  postupdateappliedbundleallocations,
  holdappliedallocations,
  holdbundleappliedallocations,
  criteriamessage,
  updatedatetime,
  importexportallocationpointsdata,
  importexportallocationtabledata,
  getCompleteAllocation,
  getinvoicereportlist,
  resetallocation,
  deleteallocation,
  editorcliententities,
  editorvenuelist,
  generateinvoice,
  invoicestatus,
  getgeneratedinvoicelist,
  updatebulkstatus,
  getMonthlyAllocation,
  getinvoiceitem,
  updateinvoiceitem,
  getPriceChangeLogs,
  getAllocationForUpdate,
  updateAllocationPrice,
  deleteAllocationPriceChangeLogsById,
  downloadAllAsXlsInImportExportAllocation,
  downloadExcelByStatusInImportExportAllocation,
  downloadExcelForOrphanInImportExportAllocation,
  downloadPdfByStatusInImportExportAllocation,
  generatemastreimvoiceexcel,
  generatemastreinvoiceexcel,
  generatemasterinvoiceexcel,
  shopperwiseinvoiceexcel,
  shopperinvoiceexcel,
  shopperinvoicepdf,
  getStarRankingReportYTD
} from './ApiEndPoint.tsx'
import { baseApiCall } from './BaseApiCall.tsx'

export const ApiUsersLogin = (data: any) => {
  return baseApiCall({
    url: usersLogin,
    method: 'post',
    data
  })
}

export const ApiGetAllRoles = (data: any) => {
  return baseApiCall({
    url: getAllRoles,
    method: 'get',
    data
  })
}

export const ApiGetAdminList = (data = '') => {
  return baseApiCall({
    url: getAdminList + data,
    method: 'get'
  })
}
export const ApiGetClientEntities = (data?: any) => {
  return baseApiCall({
    url: data ? getClientEntities + data : getClientEntities,
    method: 'get',
    data
  })
}

export const ApiGetUserDetails = (id: any) => {
  return baseApiCall({
    url: getUserDetails + id,
    method: 'get'
  })
}
export const ApiPostCreateAdmin = (data: any) => {
  return baseApiCall({
    url: postCreateAdmin,
    method: 'post',
    data
  })
}
export const ApiPutUpdateClient = (data: any) => {
  return baseApiCall({
    url: putUpdateClient,
    method: 'put',
    data
  })
}

export const ApiPostCreateClient = (data: any) => {
  return baseApiCall({
    url: postCreateClient,
    method: 'post',
    data
  })
}
export const ApiGetClients = (data?: any) => {
  return baseApiCall({
    url: getClients + data,
    method: 'get'
  })
}
export const ApiPutDeleteClient = (clientId: any) => {
  return baseApiCall({
    url: putDeleteClient + clientId,
    method: 'put'
  })
}
export const ApiPutStoreStatus = (data: any) => {
  return baseApiCall({
    url: putStoreStatus,
    method: 'put',
    data
  })
}
export const ApiPutUpdateClientEntity = (data: any) => {
  return baseApiCall({
    url: putUpdateClientEntity,
    method: 'put',
    data
  })
}
export const ApiPostCreateClientEntity = (data: any) => {
  return baseApiCall({
    url: postCreateClientEntity,
    method: 'post',
    data
  })
}

export const ApiGetEntityTypeList = () => {
  return baseApiCall({
    url: getEntityTypeList,
    method: 'get'
  })
}

export const ApiGetVenueList = (data: any) => {
  return baseApiCall({
    url: getVenueList + data,
    method: 'get'
  })
}
export const ApiPutVenueStatus = (data: any) => {
  return baseApiCall({
    url: putVenueStatus,
    method: 'put',
    data
  })
}

export const ApiPostCreateVenue = (data: any) => {
  return baseApiCall({
    url: postCreateVenue,
    method: 'post',
    data
  })
}
export const ApiPutUpdateVenue = (data: any) => {
  return baseApiCall({
    url: putUpdateVenue,
    method: 'put',
    data
  })
}

export const ApiPutUpdateAdminDetails = (data: any) => {
  return baseApiCall({
    url: putUpdateAdminDetails,
    method: 'put',
    data
  })
}

export const ApiPutUpdateAdminRole = (data: any) => {
  return baseApiCall({
    url: putUpdateAdminRole,
    method: 'put',
    data
  })
}

export const ApiPutUpdateAdminStatus = (data: any) => {
  return baseApiCall({
    url: putUpdateAdminStatus,
    method: 'put',
    data
  })
}

export const ApiGetShopType = () => {
  return baseApiCall({
    url: getShopType,
    method: 'get'
  })
}

export const ApiGetStarRating = () => {
  return baseApiCall({
    url: getStarRating,
    method: 'get'
  })
}
export const ApiGetBriefJson = (data='') => {
  return baseApiCall({
    url: getBriefJson + data,
    method: 'get'
  })
}
export const ApiPutBriefJson = (data: any) => {
  return baseApiCall({
    url: getBriefJson,
    method: 'put',
    data
  })
}

export const ApiPostBriefJson = (data: any) => {
  return baseApiCall({
    url: getBriefJson,
    method: 'post',
    data
  })
}

export const ApiPutUpdateEditors = (data: any) => {
  return baseApiCall({
    url: putUpdateEditors,
    method: 'put',
    data
  })
}

export const ApiPutVenueUpdateEditors = (data: any) => {
  return baseApiCall({
    url: putVenueEditors,
    method: 'put',
    data
  })
}

export const ApiGetClientEntityListById = (data: any) => {
  return baseApiCall({
    url: getClientEntities + data,
    method: 'get'
  })
}

export const ApiGetVisitTimes = () => {
  return baseApiCall({
    url: getVisitTimes,
    method: 'get'
  })
}

export const ApiPostVisitTimes = (data: any) => {
  return baseApiCall({
    url: postVisitTimes,
    method: 'post',
    data
  })
}

export const ApiPutVisitTimes = (data: any) => {
  return baseApiCall({
    url: putVisitTimes,
    method: 'put',
    data
  })
}

export const ApiPostClientEntityTemplate = (data: any) => {
  return baseApiCall({
    url: postClientEntityTemplate,
    method: 'post',
    data
  })
}

export const ApiGetClientEntitiTemplate = (data: any) => {
  return baseApiCall({
    url: getClientEntityTemplateByClientEntityId + data,
    method: 'get'
  })
}

export const ApiPutClientEntityTemplate = (data: any) => {
  return baseApiCall({
    url: putClientEntityTemplate,
    method: 'put',
    data
  })
}

export const ApiPostVenueTemplate = (data: any) => {
  return baseApiCall({
    url: postVenueTemplate,
    method: 'post',
    data
  })
}
export const ApiPutVenueTemplate = (data: any) => {
  return baseApiCall({
    url: postVenueTemplate,
    method: 'put',
    data
  })
}

export const ApiGetVenueEntityTemplate = (data: any) => {
  return baseApiCall({
    url: getVenueEntityTemplateByClientEntityId + data,
    method: 'get'
  })
}

export const ApiGetAllocations = (data: any) => {
  return baseApiCall({
    url: getAllocations + data,
    method: 'get'
  })
}
export const ApiGetAdminMonthlyAllocations = (data: any) => {
  return baseApiCall({
    url: getMonthlyAllocation + data,
    method: 'get'
  })
}
export const ApiPutUpdateAllocation = (data: any) => {
  return baseApiCall({
    url: putUpdateAllocation,
    method: 'put',
    data
  })
}
export const ApiPostCreateAllocations = (data: any) => {
  return baseApiCall({
    url: postCreateAllocations,
    method: 'post',
    data
  })
}
export const ApiGetShopper = (data: any) => {
  return baseApiCall({
    url: getShopper + data,
    method: 'get'
  })
}
export const ApiGetOrphanAllocations = (data: any) => {
  return baseApiCall({
    url: getOrphanAllocations + data,
    method: 'get'
  })
}

export const ApiGetNearbyShopper = (data: any) => {
  return baseApiCall({
    url: getNearbyShopper + data,
    method: 'get'
  })
}

export const ApiGetShoppersApplication = (data) => {
  return baseApiCall({
    url: getAllShoppersApplications + data,
    method: 'get'
  })
}

export const ApiPutUpdateShopperApplicationStatus = (data: any) => {
  return baseApiCall({
    url: putUpdateShopperApplicationStatus,
    method: 'put',
    data
  })
}

export const ApiGetAppliedAllocations = (data: any) => {
  return baseApiCall({
    url: getAppliedAllocations + data,
    method: 'get',
  })
}

export const ApiPostUpdateAppliedAllocationStatus = (data: any) => {
  return baseApiCall({
    url: postUpdateAppliedAllocationStatus,
    method: 'post',
    data
  })
}

export const ApiPostInviteShopper = (data: any) => {
  return baseApiCall({
    url: postInviteShopper,
    method: 'post',
    data
  })
}
export const GetCategories = () => {
  return baseApiCall({
    url: getcategories,
    method: 'get',
  })
}
export const GetEntities = () => {
  return baseApiCall({
    url: getentities,
    method: 'get',
  })
}
export const AddNewQuestion = (data: any) => {
  return baseApiCall({
    url: addquestions,
    method: 'post',
    data
  })
}
export const UpdateQuestion = (data: any) => {
  return baseApiCall({
    url: updatequestions,
    method: 'put',
    data
  })
}
export const GetQuestions = (offset: number, limit: number, entityTypeId: number | string, categoryId: number | string, search: string) => {
  return baseApiCall({
    url: `${getquestions}?offset=${search.length > 0 ? 0 : offset}&limit=${limit}${categoryId !== 0 ? `&categoryId=${categoryId}`: ''}${entityTypeId !== 0 ? `&entityTypeId=${entityTypeId}`:''}${search?.length > 0 ? `&search=${search}`:''}&isActive=1`,
    method: 'get',
  })
}
export const DeleteQuestionTemplate = (entityTypeTemplateId: number) => {
  return baseApiCall({
    url: `${deletequestiontemplate}?entityTypeTemplateId=${entityTypeTemplateId}`,
    method: 'delete',
  })
}
export const GetQuestionTemplate = () => {
  return baseApiCall({
    url: getquestiontemplate,
    method: 'get',
  })
}
export const ApiPostUploadVenueImage = (data: any) => {
  return baseApiCall({
    url: uploadVenueImage,
    method: 'post',
    data
  })
}
export const AddQuestionTemplate = (data: any) => {
  return baseApiCall({
    url: addquestiontemplate,
    method: 'post',
    data
  })
}
export const UpdateQuestionTemplate = (data: any) => {
  return baseApiCall({
    url: updatequestiontemplate,
    method: 'put',
    data
  })
}
export const GetTemplateQuestions = (entityTypeTemplateId: number) => {
  return baseApiCall({
    url: `${gettemplatequestions}?&entityTypeTemplateId=${entityTypeTemplateId}`,
    method: 'get',
  })
}
export const GetClientEntityQuestions = (clientEntityId: number) => {
  return baseApiCall({
    url: `${getcliententityquestions}?&clientEntityId=${clientEntityId}`,
    method: 'get',
  })
}
export const AddTemplateQuestions = (data: any) => {
  return baseApiCall({
    url: addtemplatequestions,
    method: 'post',
    data
  })
}
export const AddBusinessQuestions = (data: any) => {
  return baseApiCall({
    url: addbusinessquestions,
    method: 'post',
    data
  })
}
export const RemoveTemplateQuestions = (entityTypeTemplateQuestionId: number) => {
  return baseApiCall({
    url: `${removetemplatequestions}?entityTypeTemplateQuestionId=${entityTypeTemplateQuestionId}`,
    method: 'post',
    // data
  })
}
export const RemoveClientQuestions = (clientEntityQuestionId: number | boolean, clientEntityId: number) => {
  return baseApiCall({
    url: `${removebusinessquestions}?${clientEntityQuestionId === true ? 'allDataNeedToDelete' : 'clientEntityQuestionId'}=${clientEntityQuestionId}&clientEntityId=${clientEntityId}`,
    method: 'delete',
    // data
  })
}
export const UpdateBusinessQuestions = (data: any) => {
  return baseApiCall({
    url: updatebusinessquestions,
    method: 'put',
    data
  })
}

export const AddVenueQuestions = (data: any) => {
  return baseApiCall({
    url: addvenuequestions,
    method: 'post',
    data
  })
}
export const GetVenueQuestions = (venueId: number) => {
  return baseApiCall({
    url: `${getvenuequestions}?venueId=${venueId}`,
    method: 'get',
  })
}
export const RemoveVenueQuestions = (clientEntityQuestionVenueId: number | boolean, venueId: number) => {
  return baseApiCall({
    url: `${removevenuequestions}?${clientEntityQuestionVenueId === true ? 'allDataNeedToDelete' : 'clientEntityQuestionVenueId'}=${clientEntityQuestionVenueId}&venueId=${venueId}`,
    method: 'delete',
    // data
  })
}
export const UpdateVenueQuestions = (data: any) => {
  return baseApiCall({
    url: updatevenuequestions,
    method: 'put',
    data
  })
}
export const UpdateVenueQuestionOrder = (data: any) => {
  return baseApiCall({
    url: updatevenuequestionorder,
    method: 'post',
    data
  })
}
export const UpdateVenueCategoryOrder = (data: any) => {
  return baseApiCall({
    url: updatevenuecategoryorder,
    method: 'post',
    data
  })
}
export const ApiPutCancelJob = (data: any) => {
  return baseApiCall({
    url: putCancelJob + data,
    method: 'put'
  })
}

export const ApiGetClientDbName = () => {
  return baseApiCall({
    url: getClientDbName,
    method: 'get'
  })
}
export const ApiMasterRating = () => {
  return baseApiCall({
    url: masterRating,
    method: 'get'
  })
}

// export const ApiReportList = (page: number, rowsperpage: number, reportMonth: number, reportYear: number, reportstatusId: number) => {
//   return baseApiCall({
//     url: `${reportlist}?offset=${page}&limit=${rowsperpage}&reportMonth=${reportMonth}&reportYear=${reportYear}&reportStatusId=${reportstatusId}`,
//     method: 'get',
//   })
// }
// export const ApiShopperFeedback = (reportHeaderId: number) => {
//   return baseApiCall({
//     url: `${getShopperFeedback}?reportHeaderId=${reportHeaderId}`,
//     method: 'get',
//   })
// }
// export const ApiPostShopperFeedback = (data: any) => {
//   return baseApiCall({
//     url: postShopperFeedback,
//     method: 'post',
//     data
//   })
// }
export const ApiUpdateVisitTime = (data: any) => {
  return baseApiCall({
    url: updatevisittime,
    method: 'put',
    data
  })

}

// export const ApiCallGetReportDetails = (data: any) => {
//   return baseApiCall({
//     url: getReportDetails + data,
//     method: 'get',
//   })
// }

// export const ApiScoreCardStep1 = (data: any) => {
//   return baseApiCall({
//     url: scoreCardStep1,
//     method: 'post',
//     data
//   });
// }

// export const ApiScoreCardStep2 = (data: any) => {
//   return baseApiCall({
//     url: scoreCardStep2,
//     method: 'post',
//     data
//   });
// }

// export const ApiScoreCardStep3 = (data: any) => {
//   return baseApiCall({
//     url: scoreCardStep3,
//     method: 'post',
//     data
//   });
// }

export const ApiDeletePhotos = (data: any) => {
  return baseApiCall({
    url: deletePhotos,
    method: 'Delete',
    data
  });
}

export const ApiGenerateReportPdf = (data: any) => {
  return baseApiCall({
    url: reportPdf + data,
    method: 'get',
  });
}

// export const ApiUpdateReportStatus = (data: any) => {
//   return baseApiCall({
//     url: updateReportStatus,
//     method: 'put',
//     data
//   })
// }

export const ApiGetStarRatingReport = (data?: any) => {
  return baseApiCall({
    url: getStarRatingReport + data,
    method: 'get',
  })
}
export const ApiGetSpentReport = (data?: any) => {
  return baseApiCall({
    url: getSpentReport + data,
    method: 'get',
  })
}
console.log("Spend Report from call ", getSpentReport);

export const ApiGetClientEntityByClientGroupId = (data: any) => {
  return baseApiCall({
    url: getClientEntityByClientGroupId + data,
    method: 'get'
  })
}

export const ApiAddAreaManager = (data: any) => {
  return baseApiCall({
    url: postAreaManager,
    method: 'post',
    data
  })
}

export const ApiGetAreaManager = () => {
  return baseApiCall({
    url: getAreaManagers,
    method: 'get'
  })
}

export const ApiUpdateAreaManager = (data: any) => {
  return baseApiCall({
    url: putAreaManager,
    method: 'put',
    data
  })
}

export const ApiGetAddOnQuestions = () => {
  return baseApiCall({
    url: getAddOnQuestions,
    method: 'get'
  })
}

export const ApiuploadDocuments = (data: any) => {
  return baseApiCall({
    url: uploadDocuments,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
export const ApiPostQuizQuestion = (data: any) => {
  return baseApiCall({
    url: postQuizQuestion,
    method: 'post',
    data
  })
}

export const ApiGetQuizQuestions = (data: any) => {
  return baseApiCall({
    url: getQuizQuestions + data,
    method: 'get'
  })
} 

export const ApiPutQuizQuestion = (data: any) => {
  return baseApiCall({
    url: putQuizQuestions,
    method: 'put',
    data
  })
}

export const ApiGetShopperList = (data: any = '') => {
  return baseApiCall({
    url: getShopperList + data,
    method: 'get',
  })
}

export const ApiPutShopperDetails = (data: any) => {
  return baseApiCall({
    url: putShopperDetails,
    method: 'put',
    data
  })
}

export const ApiPutShopperFinancialDetails = (data: any) => {
  return baseApiCall({
    url: putShopperFinancialDetails,
    method: 'put',
    data
  })
}

export const ApiGetShopperDetails = (data: any) => {
  return baseApiCall({
    url: getShopperDetails + data,
    method: 'get'
  })
}

export const ApiGetShopperRelativeVenues = (data: any) => {
  return baseApiCall({
    url: getShopperRelativeVenues + data,
    method: 'get'
  })
}

export const ApiGetShopperVenueMap = (data: any) => {
  return baseApiCall({
    url: getShopperVenueMap + data,
    method: 'get'
  })
}

export const ApiGetShopperPopUpDetails = (data: any) => {
  return baseApiCall({
    url: getShopperPopUpDetails + data,
    method: 'get'
  })
}

export const ApiGetManageRegions = () => {
  return baseApiCall({
    url: getManageRegions,
    method: 'get'
  })
}

export const ApiPostRegion = (data: any) => {
  return baseApiCall({
    url: postRegion,
    method: 'post',
    data
  })
}

export const ApiPutRegion = (data: any) => {
  return baseApiCall({
    url: putRegion,
    method: 'put',
    data
  })
}

export const ApiPostAssignRegionToClientEntity = (data: any) => {
  return baseApiCall({
    url: postAssignRegionToClientEntity,
    method: 'post',
    data
  })
}

export const ApiGetBusinessRegions = (data: any) => {
  return baseApiCall({
    url: getBusinessRegions + data,
    method: 'get'
  })
}
export const ApiGetClientEntityComparisionsByEntityType = (data: any) => {
  return baseApiCall({
    url: getClientEntityComparisionsByEntityType,
    method: 'post',
    data:data
  })
}

export const ApiGetVenuePreviousReports = (data: any) => {
  return baseApiCall({
    url: getVenuePreviousReport + data,
    method: 'get',
  })
}

export const ApiGetApproveAllocationShopper = (data: any) => {
  return baseApiCall({
    url: getApprovedAllocationShopper + data,
    method: 'get',
  })
}
export const ApiGetCategoryList = () => {
  return baseApiCall({
    url: getCategoryList,
    method: 'get'
  })
}
export const ApiAddCategory = (data:any) => {
  return baseApiCall({
    url: addCategory,
    method: 'post',
    data
  })
}
export const ApiUpdateCategory = (data:any) => {
  return baseApiCall({
    url: updateCategory,
    method: 'put',
    data
  })
}
export const ApiQuizreTake = (data:any) => {
  return baseApiCall({
    url: quizreTake,
    method: 'put',
    data
  })
}

export const ApiGetRegionBusinessDetails = () => {
  return baseApiCall({
    url: getRegionBusinessDetails,
    method: 'get'
  })
}

export const ApiPostRegionBusinessDetail = (data: any) => {
  return baseApiCall({
    url: postregionBusinessDetail,
    method: 'post',
    data
  })
}

export const ApiPutquizBrief = (data: any) => {
  return baseApiCall({
    url: putQuizBrief,
    method: 'put',
    data
  })
}

export const ApiDeleteReportMessage = (data: any) => {
  return baseApiCall({
    url: delReportMessage + data,
    method: 'delete',
  });
}

export const ApiGetAllocationCriteriaDetails = (data:any) => {
  return baseApiCall({
    url: getAllocationCriteriaDetails + data,
    method: 'get',
    // data
  })
}

export const ApicreateAirTasker = (data:any) => {
  return baseApiCall({
    url: createAirTasker,
    method: 'post',
    data
  })
}

export const ApiupdateAirTasker = (data:any) => {
  return baseApiCall({
    url: updateAirTasker,
    method: 'put',
    data
  })
}

export const ApideleteAirTasker = (data:any) => {
  return baseApiCall({
    url: deleteAirTasker,
    method: 'put',
    data
  })
}

export const ApiGetAirTasker = (data:any) => {
  return baseApiCall({
    url: getAirTasker + data,
    method: 'get'
  })
}
export const ApiGetAllocationlist = (data:any) => {
  return baseApiCall({
    url: getallocations+ data,
    method: 'get'
  })
}

export const ApideleteInvitedAirTasker = (data:any) => {
  return baseApiCall({
    url: deleteInvitedAirTasker,
    method: 'put',
    data
  })
}
export const ApiCreateBundleAllocation = (data:any) => {
  return baseApiCall({
    url: createbundleallocations,
    method: 'post',
    data
  })
}
export const ApiGetBundleList = (data = '') => {
  return baseApiCall({
    url: getbundlelist + data,
    method: 'get',
  })
}
export const ApiGetBundleAllocations = (data) => {
  return baseApiCall({
    url: getbundleallocations + data,
    method: 'get',
    data
  })
}
export const ApiGetAppliedBundleAllocations = (data) => {
  return baseApiCall({
    url: getappliedbundleallocations + data,
    method: 'get',
    data
  })
}
export const ApiPostUpdateBundleAppliedAllocationStatus = (data: any) => {
  return baseApiCall({
    url: postupdateappliedbundleallocations,
    method: 'post',
    data
  })
}
export const ApiHoldAppliedAllocation = ( data1:any,data2:any) => {
  return baseApiCall({
    url: holdappliedallocations+data1,
    method: 'post',
    data:data2
  })
}
export const ApiHoldBundleAppliedAllocation = (data1: any, data2:any) => {
  return baseApiCall({
    url: holdbundleappliedallocations+data1,
    method: 'post',
    data:data2
  })
}
export const ApiCriteriaMessage = (data1: any) => {
  return baseApiCall({
    url: criteriamessage + data1,
    method: 'get',
  })
}
export const ApiUpdateDateTime = (data: any) => {
  return baseApiCall({
    url: updatedatetime,
    method: 'put',
    data
  })
}
export const ApiImportExportAllocationTable = (data: any) => {
  return baseApiCall({
    url: importexportallocationtabledata + data,
    method: 'get',
    data
  })
}
export const ApiImportExportAllocationPoints = (data: any) => {
  return baseApiCall({
    url: importexportallocationpointsdata + data,
    method: 'get',
    data
  })
}
export const ApiGetCompleteAllocation = (data: any) => {
  return baseApiCall({
    url:getCompleteAllocation + data,
    method: 'get',
  })
}
export const ApiGetInvoiceReportList = (data: any) => {
  return baseApiCall({
    url: getinvoicereportlist + data,
    method: 'get',
  })
}
export const ApiResetAllocation = (data: any) => {
  return baseApiCall({
    url: resetallocation + data,
    method: 'put',
  })
}
export const ApiDeleteAllocation = (data: any) => {
  return baseApiCall({
    url: deleteallocation + data,
    method: 'del',
  })
}
export const ApiEditorClientEntities = (data: any) => {
  return baseApiCall({
    url: editorcliententities + data,
    method: 'get',
  })
}
export const ApiEditorVenueList = (data: any) => {
  return baseApiCall({
    url: editorvenuelist + data,
    method: 'get',
  })
}

export const ApiGenerateInvoice = (data: any) => {
  return baseApiCall({
    url: generateinvoice,
    method: 'post',
    data
  })
}
export const ApiGetInvoiceStatus = () => {
  return baseApiCall({
    url: invoicestatus,
    method: 'get',
  })
}
export const ApiGetGeneratedInvoiceList = (data) => {
  return baseApiCall({
    url: getgeneratedinvoicelist + data,
    method: 'get',
  })
}
export const ApiUpdateBulkStatus = (data) => {
  return baseApiCall({
    url: updatebulkstatus,
    method: 'put',
    data
  })
}
export const ApiGetInvoiceItem = (data: any) => {
  return baseApiCall({
    url: getinvoiceitem + data,
    method: 'get',
  })
}
export const ApiUpdateInvoiceItem = (data: any) => {
  return baseApiCall({
    url: updateinvoiceitem ,
    method: 'put',
    data
  })
}
export const ApiGetPriceChangeLogs = (data: any) => {
  return baseApiCall({
    url: getPriceChangeLogs + data ,
    method: 'get',
  })
}
export const ApiGetAllocationForUpdate = (data: any) => {
  return baseApiCall({
    url: getAllocationForUpdate + data ,
    method: 'get',
  })
}
export const ApiUpdateAllocationPrice = (data: any) => {
  return baseApiCall({
    url: updateAllocationPrice ,
    method: 'put',
    data
  })
}
export const ApiDeleteAllocationPriceChangeLogsById = (data: any) => {
  return baseApiCall({
    url: deleteAllocationPriceChangeLogsById + data,
    method: 'delete',
  });
}
export const ApiDownloadAllAsXlsInImportExportAllocation = (data: any) => {
  return baseApiCall({
    url: downloadAllAsXlsInImportExportAllocation + data ,
    method: 'get',
    responseType: 'blob'
  })
}
export const ApiDownloadExcelByStatusInImportExportAllocation = (data: any) => {
  return baseApiCall({
    url: downloadExcelByStatusInImportExportAllocation + data ,
    method: 'get',
    responseType: 'blob'
  })
}
export const ApiDownloadExcelForOrphanInImportExportAllocation = (data: any) => {
  return baseApiCall({
    url: downloadExcelForOrphanInImportExportAllocation + data ,
    method: 'get',
    responseType: 'blob'
  })
}
export const ApiDownloadPdfByStatusInImportExportAllocation = (data: any) => {
  return baseApiCall({
    url: downloadPdfByStatusInImportExportAllocation + data ,
    method: 'get',
    responseType: 'blob',
    fullResponse: true
  })
}
export const ApiGenerateMasterInvoice= (data: any) => {
  return baseApiCall({
    url: generatemasterinvoiceexcel + data ,
    method: 'post',
    responseType: 'blob',
    fullResponse: true
  })
}
export const ApiGenerateShopperWiseInvoice= (data: any) => {
  return baseApiCall({
    url: shopperwiseinvoiceexcel + data ,
    method: 'post',
    responseType: 'blob',
    fullResponse: true
  })
}
export const ApiGenerateShopperInvoice= (data: any) => {
  return baseApiCall({
    url: shopperinvoiceexcel + data ,
    method: 'post',
    responseType: 'blob',
    fullResponse: true
  })
}
export const ApiGenerateShopperInvoicePDF= (data: any) => {
  return baseApiCall({
    url: shopperinvoicepdf + data ,
    method: 'post',
    responseType: 'blob',
    fullResponse: true
  })
}
export const ApiGetStarRankingReportYTD= (data: any) => {
  return baseApiCall({
    url: getStarRankingReportYTD+ data ,
    method: 'get'
  })
}